import { computed } from 'vue';
import { createSharedComposable, StorageSerializers, useStorage } from '@vueuse/core';

export const VERSION_SWITCH_DEBUG_STORAGE_KEY = 'novelty-search:version-switch-debug';
export const DEBUG_REGION_STORAGE_KEY = 'debug_region';

export type DebugRegion = 'cn' | 'us';

/**
 * 判断当前浏览器是否仍有会改变业务行为的 Debug 覆盖。
 */
export function resolveHasBusinessMock(state: {
    forceEnableNewVersion: boolean;
    debugRegionOverride: unknown;
}): boolean {
    return state.forceEnableNewVersion
        || state.debugRegionOverride !== null;
}

// eslint-disable-next-line max-lines-per-function
export const useDebugSettings = createSharedComposable(() => {
    const forceEnableNewVersion = useStorage(
        VERSION_SWITCH_DEBUG_STORAGE_KEY,
        false,
        undefined,
        { writeDefaults: false },
    );
    const storedDebugRegionOverride = useStorage<string | null>(
        DEBUG_REGION_STORAGE_KEY,
        null,
        undefined,
        {
            writeDefaults: false,
            serializer: StorageSerializers.string,
        },
    );

    const debugRegionOverride = computed<DebugRegion | null>({
        get() {
            return storedDebugRegionOverride.value === 'cn' || storedDebugRegionOverride.value === 'us'
                ? storedDebugRegionOverride.value
                : null;
        },
        set(value) {
            storedDebugRegionOverride.value = value;
        },
    });
    const hasBusinessMock = computed(() => resolveHasBusinessMock({
        forceEnableNewVersion: forceEnableNewVersion.value,
        debugRegionOverride: storedDebugRegionOverride.value,
    }));

    return {
        forceEnableNewVersion,
        debugRegionOverride,
        hasBusinessMock,
    };
});
